export default __webpack_public_path__ + "3a4ba6f3a5786ee8af9577a5838d2b55.png";